<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">{{title}}</v-card-title>

    <v-card-text>

        <v-date-picker
            v-model="my_date"
            show-current
            full-width
            type="date"
            :range="range"
        >
        </v-date-picker>

        <div
            style="text-align: center"
            v-if="optional"
        >
            <a
                v-on:click="onClickClear"
            >Select no date (Clear)</a>
        </div>

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>


export default {
    props: {
        title: {
            type: String,
            default: function() { return 'Select a date'; }
        },

        range: {
            type: Boolean,
            default: function() { return false; }
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            dialog: false,
            my_date: new Date(),
        }
    },

    methods: {
        showDialog(date) 
        {
            this.my_date = date;
            this.dialog = true;    
        },

        today()
        {
           return new Date().toISOString().substr(0, 10);
        },
        
        onOk()
        {
           this.dialog = false;

           this.$emit('ok',this.my_date);
        },

        onClickClear()
        {
            this.my_date = null;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>